import * as fetch from '../../../utils/action'
import { downloadFilename, getTotalNumber } from '../totalMethod'
import timeutils from 'utils/wt-time-utils'
import mallDatas from '../datas/mall'
import { workOrderType } from 'json/mall-options'
import { getEnumeration } from 'enumeration'
import { getReservationTime } from '../../../utils/action'

export default {
  createdGoodsDraft (ctx, data) {
    return fetch.createdGoodsDraft(data).then(res => {
      return res.data
    })
  },
  // 根据商品归属查询商品类型列表
  getGoodsTypeList (ctx, data) {
    return fetch.getGoodsTypeList(data).then(res => {
      return res.data
    })
  },
  goodsList (ctx, data) {
    return fetch.goodsList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsList(result.data)
      return result
    })
  },
  salesGoodsList (ctx, data) {
    return fetch.goodsList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsList(result.data)
      return result
    })
  },
  goodsDetail (ctx, id) {
    return fetch.goodsDetail(id).then(res => {
      let result = res.data
      result = mallDatas.goodsDetail(result, true)
      return result
    })
  },
  // 商品详情页/编辑面调用（有促销活动信息）
  salesGoodsDetail (ctx, data) {
    let { id, isEdit } = data
    return fetch.salesGoodsDetail(id).then(res => {
      let result = res.data
      result = mallDatas.goodsDetail(result, isEdit)
      return result
    })
  },

  goodsDelete (ctx, id) {
    return fetch.goodsDelete(id).then(res => {
      return res.data
    })
  },
  goodsRecommend (ctx, id) {
    return fetch.goodsRecommend(id).then(res => {
      return res.data
    })
  },
  goodsRecommendCancel (ctx, id) {
    return fetch.goodsRecommendCancel(id).then(res => {
      return res.data
    })
  },
  updateRanking (ctx, data) {
    return fetch.updateRanking(data).then(res => {
      return res.data
    })
  },
  goodsPublish (ctx, data) {
    return fetch.goodsPublish(data).then(res => {
      return res.data
    })
  },
  applyForApproval (ctx, id) {
    return fetch.applyForApproval(id).then(res => {
      return res.data
    })
  },
  approvalReject (ctx, id) {
    return fetch.approvalReject(id).then(res => {
      return res.data
    })
  },
  getGoodsGroup (ctx, data) {
    return fetch.getGoodsGroup(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsGroupList(result.data)
      return result
    })
  },
  goodsOffShelves (ctx, id) {
    return fetch.goodsOffShelves(id).then(res => {
      return res.data
    })
  },
  newGoodsGroup (ctx, data) {
    return fetch.newGoodsGroup(data).then(res => {
      return res.data
    })
  },
  newIntegralGoodsGroup (ctx, data) {
    return fetch.newIntegralGoodsGroup(data).then(res => {
      return res.data
    })
  },
  goodsGroupDetail (ctx, id) {
    return fetch.goodsGroupDetail(id).then(res => {
      return res.data
    })
  },
  integralGoodsGroupDetail (ctx, id) {
    return fetch.integralGoodsGroupDetail(id).then(res => {
      return res.data
    })
  },
  integralGroupEdit (ctx, data) {
    return fetch.integralGroupEdit(data).then(res => {
      return res.data
    })
  },
  getDetectionPackageEntities (ctx, data) {
    return fetch.getDetectionPackageEntities(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.getDetectionPackageEntities(result.data)
      return result
    })
  },
  shippingAddress (ctx, id) {
    return fetch.shippingAddress(id).then(res => {
      let result = res.data
      return result
    })
  },
  creatDeliverGoodsDetail (ctx, data) {
    return fetch.creatDeliverGoodsDetail(data).then(res => {
      return res
    })
  },
  applyForRefundment (ctx, data) {
    return fetch.applyForRefundment(data).then(res => {
      return res
    })
  },
  approvalRefundment (ctx, data) {
    return fetch.approvalRefundment(data).then(res => {
      return res
    })
  },
  // 获取优惠劵列表
  getCouponsList (ctx, data) {
    return fetch.getCouponsList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.getCouponsList(result.data)
      return result
    })
  },
  createCoupons (ctx, data) {
    return fetch.createCoupons(data).then(res => {
      let result = res.data
      return result
    })
  },
  saveCoupons (ctx, data) {
    return fetch.saveCoupons(data).then(res => {
      let result = res.data
      return result
    })
  },
  couponDetail (ctx, data) {
    return fetch.couponDetail(data).then(res => {
      let result = res.data
      result = mallDatas.couponDetail(result)
      return result
    })
  },
  couponEdit (ctx, data) {
    return fetch.couponEdit(data).then(res => {
      let result = res.data
      return result
    })
  },
  coupontDelete (ctx, id) {
    return fetch.coupontDelete(id).then(res => {
      let result = res.data
      return result
    })
  },
  couponUpdateStatus (ctx, data) {
    return fetch.couponUpdateStatus(data).then(res => {
      let result = res.data
      return result
    })
  },
  downloadPrivateResource (ctx, data) {
    return fetch.downloadPrivateResource(data).then(res => {
      return res.data
    })
  },
  createPromotion (ctx, data) {
    return fetch.createPromotion(data).then(res => {
      return res.data
    })
  },
  getPromotionList (ctx, data) {
    return fetch.getPromotionList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.getPromotionList(result.data)
      return result
    })
  },
  // 促销活动详情
  promotionDetail (ctx, data) {
    return fetch.promotionDetail(data).then(res => {
      let result = mallDatas.promotionDetail(res.data)
      return result
    })
  },
  // 删除促销活动
  promotionDelete (ctx, id) {
    return fetch.promotionDelete(id).then(res => {
      return res.data
    })
  },
  // 更改促销活动状态
  promotionStatus (ctx, data) {
    return fetch.promotionStatus(data).then(res => {
      return res.data
    })
  },
  // 编辑促销活动
  promotionEdit (ctx, data) {
    return fetch.promotionEdit(data).then(res => {
      return res.data
    })
  },
  technologyCycle (ctx, type) {
    return fetch.technologyCycle(type).then(res => {
      let result = mallDatas.technologyCycle(res.data)
      return result
    })
  },
  groupDelete (ctx, id) {
    return fetch.groupDelete(id).then(res => {
      return res.data
    })
  },
  integralGroupDelete (ctx, id) {
    return fetch.integralGroupDelete(id).then(res => {
      return res.data
    })
  },
  // 获取商城用户
  getMallUser (ctx, data) {
    return fetch.getMallUser(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.getMallUser(result.data)
      return result
    })
  },
  // 后台商品分组，商品列表排序接口
  goodsSort (ctx, data) {
    return fetch.goodsSort(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsList(result.data)
      return result
    })
  },
  salesGoodsSort (ctx, data) {
    return fetch.salesGoodsSort(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsList(result.data)
      return result
    })
  },
  // 获取广告位列表
  getBannerList (ctx, data) {
    return fetch.getBannerList(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  // 获取所有的广告位定义
  bannersPositions (ctx, data) {
    return fetch.bannersPositions(data).then(res => {
    //   let result = getTotalNumber(res)
      let result = mallDatas.bannersPositions(res.data)
      return result
    })
  },
  // 替换指定位置上的所有推荐
  bannersReplace (ctx, data) {
    return fetch.bannersReplace(data).then(res => {
      return res.data
    })
  },
  // 根据条件查询推荐位列表
  bannerByExample (ctx, data) {
    return fetch.bannerByExample(data).then(res => {
      return res.data
    })
  },
  getActiveSetList (ctx, data) {
    return fetch.getActiveSetList(data).then(res => {
      return res.data
    })
  },
  bannerGoodsResources (ctx, data) {
    return fetch.bannerGoodsResources(data).then(res => {
      return res.data
    })
  },
  bannerNewsResouces (ctx, data) {
    return fetch.bannerNewsResouces(data).then(res => {
      return res.data
    })
  },
  promotionBannerUrl (ctx, data) {
    return fetch.promotionBannerUrl(data).then(res => {
      return res.data
    })
  },
  createLabels (ctx, data) {
    return fetch.createLabels(data).then(res => {
      return res.data
    })
  },
  getLabelsList (ctx, data) {
    return fetch.getLabelsList(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  labelListByName (ctx, data) {
    return fetch.labelListByName(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  editLabel (ctx, data) {
    return fetch.editLabel(data).then(res => {
      return res.data
    })
  },
  deleteLabel (ctx, id) {
    return fetch.deleteLabel(id).then(res => {
      return res.data
    })
  },
  getRelatedLabels (ctx, data) {
    return fetch.getRelatedLabels(data).then(res => {
      return res.data
    })
  },
  updateRelatedLabel (ctx, data) {
    return fetch.updateRelatedLabel(data).then(res => {
      return res.data
    })
  },
  deleteRelatedLabel (ctx, id) {
    return fetch.deleteRelatedLabel(id).then(res => {
      return res.data
    })
  },
  getVendorsOrganizations (ctx, data) {
    return fetch.getVendorsOrganizations(data).then(res => {
      let result = res.data
      return result
    })
  },
  newRefundmentReason (ctx, data) {
    return fetch.newRefundmentReason(data).then(res => {
      return res
    })
  },
  tagsObjects (ctx, data) {
    return fetch.tagsObjects(data).then(res => {
      return res.data
    })
  },
  promotionBannersPosition (ctx, data) {
    return fetch.promotionBannersPosition(data).then(res => {
      return res.data
    })
  },
  groupWithGoodsCount (ctx, data) {
    return fetch.groupWithGoodsCount(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsGroupList(result.data)
      return result
    })
  },
  integralGroupWithGoodsCount (ctx, data) {
    return fetch.integralGroupWithGoodsCount(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsGroupList(result.data)
      return result
    })
  },
  // 第三方供应商列表
  getVendorsList (ctx, data) {
    return fetch.getVendorsList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.getVendorsList(result.data)
      return result
    })
  },
  setStick (ctx, id) {
    return fetch.setStick(id).then(res => {
      return res.data
    })
  },
  cancelStick (ctx, id) {
    return fetch.cancelStick(id).then(res => {
      return res.data
    })
  },
  updateNewsRanking (ctx, id) {
    return fetch.updateNewsRanking(id).then(res => {
      return res.data
    })
  },
  setNewsStick (ctx, id) {
    return fetch.setNewsStick(id).then(res => {
      return res.data
    })
  },
  cancelNewsStick (ctx, id) {
    return fetch.cancelNewsStick(id).then(res => {
      return res.data
    })
  },
  NewsRecommend (ctx, id) {
    return fetch.NewsRecommend(id).then(res => {
      return res.data
    })
  },
  NewsRecommendCancel (ctx, id) {
    return fetch.NewsRecommendCancel(id).then(res => {
      return res.data
    })
  },
  // 获取预约工单列表
  getOrderWorkList (ctx, data) {
    return fetch.getOrderWorkList(data).then(res => {
      let result = getTotalNumber(res)
      result.data.forEach(item => {
        item.createdDate = timeutils.format(item.createdDate, 'default')
        item.order_status = getEnumeration(item.status, workOrderType)
      })
      return result
    })
  },
  // 获取预约工单详情
  getOrderWorkDetail (ctx, data) {
    return fetch.getOrderWorkDetail(data).then(res => {
      res.data.createdDate_change = timeutils.format(res.data.createdDate, 'default')
      return res.data
    })
  },
  // 预约工单修改
  OrderWorkUpdate (ctx, data) {
    return fetch.OrderWorkUpdate(data).then(res => {
      return res.data
    })
  },
  // 获取预约工单导出历史列表
  getOrderWorkHistoryList (ctx, data) {
    return fetch.getOrderWorkHistoryList(data).then(res => {
      let result = getTotalNumber(res)
      result.data.forEach(item => {
        item.createdDate = timeutils.format(item.createdDate, 'default')
      })
      return result
    })
  },
  // 获取预约工单导出历史列表
  getCommodityDetail (ctx, data) {
    return fetch.getCommodityDetail(data).then(res => {
      let data = res.data.goodsData.specifications
      return data
    })
  },
  // 下载预约工单的导出历史
  HistoryListDownload (ctx, data) {
    return fetch.HistoryListDownload(data).then(res => {
      return res
    })
  },
  // 创建第三方供应商
  createVendor (ctx, data) {
    return fetch.createVendor(data).then(res => {
      return res.data
    })
  },
  // 修改第三方供应商
  updateVendor (ctx, data) {
    return fetch.updateVendor(data).then(res => {
      return res.data
    })
  },
  getVendor (ctx, id) {
    return fetch.getVendor(id).then(res => {
      return res.data
    })
  },
  deleteVendor (ctx, id) {
    return fetch.deleteVendor(id).then(res => {
      return res.data
    })
  },
  exportVendors (ctx, data) {
    return fetch.exportVendors(data).then(res => {
      let result = downloadFilename(res)
      return result
    })
  },
  // 搜索预约工单列表
  getOrderWorkSearch (ctx, data) {
    return fetch.getOrderWorkSearch(data).then(res => {
      let result = getTotalNumber(res)
      result.data.forEach(item => {
        item.createdDate = timeutils.format(item.createdDate, 'default')
      })
      return result
    })
  },
  getVendorType (ctx) {
    return fetch.getVendorType().then(res => {
      return res.data
    })
  },
  customerBringNew (ctx, data) {
    return fetch.customerBringNew(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.customerBringNew(result.data)
      return result
    })
  },
  customerBringNewDetail (ctx, id) {
    return fetch.customerBringNewDetail(id).then(res => {
      let result = res.data
      result = mallDatas.customerBringNewDetail(result)
      return result
    })
  },
  exportOldToNew (ctx, data) {
    return fetch.exportOldToNew(data).then(res => {
      return res
    })
  },
  bringNewStatistice (ctx, ids) {
    return fetch.bringNewStatistice(ids).then(res => {
      return res.data
    })
  },
  bringNewReward (ctx, data) {
    return fetch.bringNewReward(data).then(res => {
      return res.data
    })
  },
  getQrCodeList (ctx, data) {
    return fetch.getQrCodeList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.getQrCodeList(result.data)
      return result
    })
  },
  createQrCode (ctx, data) {
    return fetch.createQrCode(data).then(res => {
      return res
    })
  },
  deleteQrCode (ctx, id) {
    return fetch.deleteQrCode(id).then(res => {
      return res
    })
  },
  downloadQrCode (ctx, id) {
    return fetch.downloadQrCode(id).then(res => {
      return res
    })
  },
  downloadQrCodeDetail (ctx, id) {
    return fetch.downloadQrCodeDetail(id).then(res => {
      return res
    })
  },
  qrCodeDetailList (ctx, data) {
    return fetch.qrCodeDetailList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.qrCodeDetailList(result.data)
      return result
    })
  },
  getBranchCompanyListWechat (ctx, data) {
    return fetch.getBranchCompanyListWechat(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  getTicketsAct (ctx) {
    return fetch.getTicketsAct().then(res => {
      return res.data
    })
  },
  // 用户海报管理选择商品的页面
  getGoodsDetailLikeList (ctx, id) {
    return fetch.salesGoodsDetail(id).then(res => {
      res = mallDatas.goodsList([res.data])[0]
      return res
    })
  },
  getCommodityDetailPoster (ctx, id) {
    return fetch.getCommodityDetailById(id).then(res => {
      res = mallDatas.goodsList([res.data])[0]
      return res
    })
  },
  getLifeExperienceHallsList (ctx, data) {
    return fetch.getLifeExperienceHallsList(data).then(res => {
      let result = getTotalNumber(res)
      result.data.forEach(item => {
        item.currentCreatedDate = timeutils.format(item.createdDate, 'default')
        item.department = item.address.provinceName + item.address.cityName
      })
      return result
    })
  },
  createLifeExperienceHallsList (ctx, id) {
    return fetch.createLifeExperienceHallsList(id).then(res => {
      return res.data
    })
  },
  editLifeExperienceHallsList (ctx, id) {
    return fetch.editLifeExperienceHallsList(id).then(res => {
      return res.data
    })
  },
  deleteLifeExperienceHallsList (ctx, id) {
    return fetch.deleteLifeExperienceHallsList(id).then(res => {
      return res.data
    })
  },
  getLifeExperienceHallsDetail (ctx, id) {
    return fetch.getLifeExperienceHallsDetail(id).then(res => {
      return res.data
    })
  },
  downloadLifeExperienceHallsQrcode (ctx, id) {
    return fetch.downloadLifeExperienceHallsQrcode(id).then(res => {
      return res.data
    })
  },
  groupEdit (ctx, data) {
    return fetch.groupEdit(data).then(res => {
      return res.data
    })
  },
  // //获取生命体验馆预约参观信息
  getLifeExperienceHallsReservation (ctx, data) {
    return fetch.getLifeExperienceHallsReservation(data).then(res => {
      return getTotalNumber(res)
    })
  },
  getReservationNotifications (ctx, data) {
    return fetch.getReservationNotifications(data).then(res => {
      return getTotalNumber(res)
    })
  },
  getReservationNotificationsNoReadCount (ctx) {
    return fetch.getReservationNotificationsNoReadCount().then(res => {
      return res.data
    })
  },
  setNotificationsIsRead (ctx, id) {
    return fetch.setNotificationsIsRead(id).then(res => {
      return res.data
    })
  },
  setAllNotificationsIsRead () {
    return fetch.setAllNotificationsIsRead().then(res => {
      return res.data
    })
  },
  // 获取生命体验馆预约参观信息详情
  getLifeExperienceHallsReservationDetail (ctx, id) {
    return fetch.getLifeExperienceHallsReservationDetail(id).then(res => {
      return res
    })
  },
  // 更新生命体验馆预约参观信息详情
  updateLifeExperienceHallsReservation (ctx, data) {
    return fetch.updateLifeExperienceHallsReservation(data).then(res => {
      return res.data
    })
  },
  getReservationDate (ctx, data) {
    return fetch.getReservationDate().then(res => {
      return res
    })
  },
  getReservationTime (ctx, data) {
    return fetch.getReservationTime(data).then(res => {
      return res
    })
  },

  // 取消生命体验馆预约参观信息
  cancelLifeExperienceHallsReservation (ctx, data) {
    return fetch.cancelLifeExperienceHallsReservation(data).then(res => {
      return res.data
    })
  },
  createLifeExperienceHallsReservationNotCan (ctx, data) {
    return fetch.createLifeExperienceHallsReservationNotCan(data).then(res => {
      return res.data
    })
  },
  updateReservationNote (ctx, data) {
    return fetch.updateReservationNote(data).then(res => {
      return res.data
    })
  },
  updateReservationStatus (ctx, data) {
    return fetch.updateReservationStatus(data).then(res => {
      return res.data
    })
  },
  getLifeExperienceHallsReservationTime () {
    return fetch.getLifeExperienceHallsReservationTime().then(res => {
      return res.data
    })
  },
  reservationExport (ctx, data) {
    return fetch.reservationExport(data).then(res => {
      return res.data
    })
  },
  // 获取带时间生命体验馆的信息
  getLifeExperienceHallsTime (ctx, data) {
    return fetch.getLifeExperienceHallsTime(data).then(res => {
      let result = res.data
      result.forEach(item => {
        item.visitTime = []
        if (item.visitDate) {
          item.visitDate.forEach(sItem => {
            item.visitTime.push({
              label: timeutils.format(sItem, 'date'),
              value: sItem
            })
          })
        }
      })
      return res.data
    })
  },
  // 获取分公司下的场馆信息
  getBranchVenuesInfo (ctx, data) {
    return fetch.getBranchVenuesInfo(data).then(res => {
      let result = res.data
      let experienceHallList = []
      result.hallInfoList.forEach(item => {
        item.visitTime = []
        if (item.visitDate) {
          item.visitDate.forEach(sItem => {
            item.visitTime.push({
              label: timeutils.format(sItem, 'date'),
              value: sItem
            })
          })
        }
        experienceHallList.push({ label: item.lifeExperienceHallDTO.name, value: item.lifeExperienceHallDTO.id })
      })
      result.experienceHallList = experienceHallList
      return res.data
    })
  }
}
